import React from "react";
import styles from "./Label.module.scss";

export interface LabelProps {
  name: string;
  htmlFor: string;
  displayValue: string;
  shouldDisplayRequired?: boolean;
}
export const Label = (props: LabelProps) => {
  return (
    <div className={styles.outer_container}>
      <label id={props.name} htmlFor={props.htmlFor} data-name={props.name} className={styles.label}>
        {props.displayValue}
      </label>
      <label className={styles.required_label}>(Required)</label>
    </div>
  );
};
